export default "__VITE_ASSET__LpucANHg__"